var render, staticRenderFns
import script from "./message_list.vue?vue&type=script&lang=js&"
export * from "./message_list.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/opt/jenkins/workspace/web-page/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('2e1fdd41')) {
      api.createRecord('2e1fdd41', component.options)
    } else {
      api.reload('2e1fdd41', component.options)
    }
    
  }
}
component.options.__file = "found/views/homeNew/components/my_dos/message_list.vue"
export default component.exports